var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tour',{staticClass:"web-editor-tour",attrs:{"name":"tour","steps":_vm.steps,"callbacks":_vm.callbacks,"options":_vm.options}})}
var staticRenderFns = []

export { render, staticRenderFns }